import { airlineFromCallsign } from "../lib/airlines.js";
import "./AirlineBadge.css";

export default function AirlineBadge({ callsign }) {
  const airline = airlineFromCallsign(callsign);
  if (!airline) return null;

  return (
    <span className="airline-badge" title={`${airline.name} — ${airline.country}`}>
      <span className="airline-badge-name">{airline.name}</span>
      <span className="airline-badge-country">{airline.country}</span>
      {airline.callsignWord ? (
        <span className="airline-badge-spoken">spoken: {airline.callsignWord}</span>
      ) : null}
    </span>
  );
}
